import React, { useState, useEffect, createContext } from 'react'
import axios from 'axios'
import { redirectToAuthWithFrom } from './UserContext'

export const PropertyContext = createContext()

export const PropertyProvider = (props) => {
  const [property, setProperty] = useState(undefined)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getProperty = async () => {
      try {
        if (props.pageType === 'visit') {
          const { data: { data: response } = {} } = await axios.post(`${process.env.REACT_APP_API}/property/details/${props.id}`)
          setProperty(response)
        } else {
          const { data: response } = await axios.get(`${process.env.REACT_APP_PROPERTY_API}/${props.id}`)
          setProperty(response)
        }
      } catch (e) {
        if (e.response.status === 401) {
          redirectToAuthWithFrom()
        }
        setProperty(undefined)
        setIsLoading(false)
      }
    }
    getProperty()
  }, [])
  return (
    <PropertyContext.Provider
      value={{
        property,
        isLoading,
      }}
    >
      {props.children}
    </PropertyContext.Provider>
  )
}
